export default __webpack_public_path__ + "static/media/StartConversation.96d86bd7.svg";